export const Datepicker = {
	selectors: {
		pickers: Array.prototype.slice.call(document.querySelectorAll('.js-datepicker')),
	},

	init: function () {
		let self = this;

		let inputs = Array.prototype.slice.call(document.querySelectorAll('.js-datepicker'));
		inputs.forEach(function(selector) {
			self.initFlatPicker(selector);
		});
	},

	initFlatPicker: function (selector) {
		let self = this;

		let instance = window.flatpickr(selector, self.getConfiguration(selector));
		if (instance.calendarContainer) {
			instance.calendarContainer.classList.add('c-datepicker');
		}

		return instance;
	},

	getConfiguration: function(selector) {
		let self = this;
		let config = Object.assign({}, selector.dataset);

		config.nextArrow = config.nextArrow || `<span class="icon-svg" aria-hidden="true"><svg class="icon-svg__svg" viewBox="0 0 20 20" width="20" height="20"><use xlink:href="${config.icons}#icon-arrow-circle-right"></use></svg></span>`;
		config.prevArrow = config.prevArrow || `<span class="icon-svg" aria-hidden="true"><svg class="icon-svg__svg" viewBox="0 0 20 20" width="20" height="20"><use xlink:href="${config.icons}#icon-arrow-circle-left"></use></svg></span>`;
		config.clickOpens = config.clickOpens || true;
		config.altInput = config.altInput || true;
		config.altFormat = config.altFormat || 'j.n.Y';
		config.locale = window.flatpickrLocale(config.locale);

		return config;
	},
};

document.addEventListener('date-inputs-added', function() {
	Datepicker.init()
});

Datepicker.init();
